// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headerAdmin {\n  background: var(--header);\n}\n.headerAdmin ion-toolbar {\n  --background: var(--header);\n}\n.headerAdmin ion-toolbar h3 {\n  color: var(--btnHeader);\n}\n.headerAdmin ion-toolbar .icon {\n  color: var(--icons);\n  fill: var(--icons);\n  font-size: 2rem;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
